import { Component, inject } from '@angular/core';
import { Router, RouterModule } from '@angular/router';
import { APP_PATHS } from '../../constants/routes.constants';
import { TranslateModule } from '@ngx-translate/core';
import { AuthService } from '../../services/auth.service';

@Component({
    selector: 'app-admin',
    standalone: true,
    imports: [RouterModule, TranslateModule],
    templateUrl: './admin.component.html',
    styleUrl: './admin.component.css'
})
export class AdminComponent {
    readonly dashboardPath = APP_PATHS.DASHBOARD;
    readonly fichasPath = APP_PATHS.CREATE_WONDER;

    private authService = inject(AuthService);
    private router = inject(Router);

    logout(): void {
        this.authService.logOut().then(() => {
            this.router.navigate([APP_PATHS.LOGIN]);
        });
    }
}
